<script lang="ts">
	import '../styles/app.css';

	import { page } from '$app/stores';
	import { goto } from '$app/navigation';
	import { base } from '$app/paths';
	import { onMount } from 'svelte';
	import { authStore } from '$lib/auth/auth.svelte';
	import { setValidationI18n, setFormInvalidFallback } from '$lib/components/form';
	import { getAppValidationI18n } from '$lib/i18n/validation-i18n';
	import { setDefaultI18n } from '@juanwag/svelte-datagrid';
	import { getDatagridI18n } from '$lib/i18n/datagrid-i18n';
	import { setUiI18n } from '$components/ui/i18n-context.svelte.js';
	import { getUiComponentsI18n } from '$lib/i18n/ui-i18n';
	import { setUiNumberFormatProvider } from '$components/ui/number-format-context.js';
	import { setUiErrorNotifier, setUiErrorMessageResolver } from '$components/ui/error-notify.js';
	import { getErrorMessage } from '$lib/utils/error';
	import { setResourceGridFetchErrorHandler } from '@adminsoft/ui/resource-select/fetch-error';
	import { handleApiError, isApiError } from '$lib/utils/api-error-handler';
	import { setRouteBasePath } from '$lib/utils/route';
	import { setAppVersionProvider } from '$api/client';
	import { loadAppSettings, getAppSettings } from '$config/app-settings';
	import { Toaster, toast } from '$lib/toast';
	import { t } from '$lib/i18n';

	setValidationI18n(getAppValidationI18n());
	setDefaultI18n(getDatagridI18n());
	setUiI18n(getUiComponentsI18n());
	// The back-office console is not tenant-scoped, so number formatting has no per-account
	// settings to read — es-AR is the fixed default across the whole app.
	setUiNumberFormatProvider(() => ({
		decimalSeparator: ',',
		groupSeparator: '.',
		decimalsQuantity: 2,
		currencySymbol: '$'
	}));
	setFormInvalidFallback(() => toast.error(t('wrongInputs')));
	setUiErrorNotifier((e) => toast.error(getErrorMessage(e)));
	setUiErrorMessageResolver((e) => getErrorMessage(e));
	setResourceGridFetchErrorHandler((err) =>
		isApiError(err) ? handleApiError(err) : toast.error(getErrorMessage(err))
	);
	setRouteBasePath(base);

	setAppVersionProvider(() => String(getAppSettings().selentorApiVersion));

	let { children } = $props();
	let initialized = $state(false);

	let isLoginPage = $derived($page.url.pathname === `${base}/login`);

	onMount(async () => {
		await loadAppSettings();
		authStore.init();
		initialized = true;

		const spinner = document.getElementById('app-spinner');
		if (spinner) {
			spinner.remove();
		}
	});

	$effect(() => {
		if (!initialized) return;
		if (!authStore.isAuthenticated && !isLoginPage) {
			goto(`${base}/login`);
		}
		if (authStore.isAuthenticated && isLoginPage) {
			goto(`${base}/`);
		}
	});
</script>

{#if initialized}
	{@render children()}
{/if}

<Toaster />
